import * as React from 'react';
import { IChangeEventHandler } from '../../_types/nav';
import TextField from '@material-ui/core/TextField';

import { ISelectorDefault, search_param } from '../../_types/search';

interface Props {
    onChange: IChangeEventHandler<search_param>;
    searchParam: search_param;
    selector_cn: string;
    disabled?: boolean;
};

export const TextSelectorDefaults = 
    (selector_cn: string): ISelectorDefault => {
        return {
            comparison: "like",
            values: [""]
        };
    };


const TextSelector: React.FC<Props> = (prop: Props) => {

    //const userState: IUserState = useContext(AuthContext);
    //const [exact, setexact] = useState<boolean>(false);

    // const _value = ():string => {
    //     let  toReturn: string = '';
    //     if (prop.searchParam.values != null && prop.searchParam.values.length > 0) {
    //         toReturn = prop.searchParam.values[0]
    //         if (toReturn == null) { toReturn = ''; }
    //     }
    //     return toReturn;
    // }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let value = event.target.value;
   
        let p = { ...prop.searchParam };
        p.values = [ value ];
        p.comparison = "like";
        prop.onChange(p);
    }

return (
    <TextField disabled={prop.disabled} label="Query" value={prop.searchParam.values[0]} onChange={handleChange}/>
)
}

export default TextSelector;